var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationMarkRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5C8.51664 17.5 7.06659 17.0601 5.83323 16.236C4.59986 15.4119 3.63856 14.2406 3.07091 12.8701C2.50325 11.4997 2.35472 9.99168 2.64411 8.53683C2.9335 7.08197 3.64781 5.7456 4.6967 4.6967C5.7456 3.64781 7.08197 2.9335 8.53683 2.64411C9.99168 2.35472 11.4997 2.50325 12.8701 3.07091C14.2406 3.63856 15.4119 4.59986 16.236 5.83323C17.0601 7.06659 17.5 8.51664 17.5 10C17.4979 11.9885 16.707 13.8949 15.3009 15.3009C13.8949 16.707 11.9885 17.4979 10 17.5V17.5ZM10 3.75C8.76387 3.75 7.5555 4.11656 6.52769 4.80332C5.49988 5.49008 4.6988 6.46619 4.22576 7.60823C3.75271 8.75027 3.62894 10.0069 3.8701 11.2193C4.11125 12.4317 4.70651 13.5453 5.58059 14.4194C6.45466 15.2935 7.56831 15.8888 8.78069 16.1299C9.99307 16.3711 11.2497 16.2473 12.3918 15.7742C13.5338 15.3012 14.5099 14.5001 15.1967 13.4723C15.8834 12.4445 16.25 11.2361 16.25 10C16.2482 8.34296 15.5891 6.7543 14.4174 5.5826C13.2457 4.41089 11.657 3.75182 10 3.75V3.75Z",
    fill: "#D00100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 5.625H9.375V11.875H10.625V5.625Z",
    fill: "#D00100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 13.125H9.375V14.375H10.625V13.125Z",
    fill: "#D00100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkRed);
export default __webpack_public_path__ + "static/media/exclamation_mark_red.2c37be99147195c542a57927a9fbc4ba.svg";
export { ForwardRef as ReactComponent };